export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.workbench.link': '歡迎使用',
  'pages.workbench.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.customerIntelligence.customerList.columns.name': '客戶名稱',
  'pages.customerIntelligence.customerList.columns.owner': '負責人',
  'pages.customerIntelligence.customerList.columns.mobile': '手機號',
  'pages.customerIntelligence.customerList.columns.email': '郵箱',
  'pages.customerIntelligence.customerList.columns.followUpStatus': '跟進狀態',
  'pages.customerIntelligence.customerList.columns.lockStatus': '鎖定狀態',
  'pages.customerIntelligence.customerList.columns.dealStatus': '成交狀態',
  'pages.customerIntelligence.customerList.columns.contactLastTime':
    '最近聯繫時間',
  'pages.customerIntelligence.customerList.columns.contactNextTime':
    '下次聯繫時間',
  'pages.customerIntelligence.customerList.search.keyword': '關鍵字',
  'pages.customerIntelligence.customerList.placeholder.empty': '-',
  'pages.customerIntelligence.customerList.empty': '暫無客戶數據',
  'pages.customerIntelligence.customerList.boolean.yes': '是',
  'pages.customerIntelligence.customerList.boolean.no': '否',
  'pages.customerIntelligence.customerList.create.button': '新增客戶',
  'pages.customerIntelligence.customerList.create.modalTitle': '新增客戶',
  'pages.customerIntelligence.customerList.create.success': '客戶已建立',
  'pages.customerIntelligence.customerList.create.form.name': '客戶名稱',
  'pages.customerIntelligence.customerList.create.form.name.required':
    '請輸入客戶名稱',
  'pages.customerIntelligence.customerList.create.form.name.placeholder':
    '請輸入客戶名稱',
  'pages.customerIntelligence.customerList.create.form.mobile': '手機號',
  'pages.customerIntelligence.customerList.create.form.telephone': '電話',
  'pages.customerIntelligence.customerList.create.form.email': '郵箱',
  'pages.customerIntelligence.customerList.create.form.qq': 'QQ',
  'pages.customerIntelligence.customerList.create.form.wechat': '微信',
  'pages.customerIntelligence.customerList.create.form.remark': '備註',
  'pages.customerIntelligence.customerList.alert.missingTenant':
    '當前租戶上下文缺失，結果可能不完整',
  'pages.customerIntelligence.customerList.alert.missingMember':
    '當前會話缺少 memberUuid，無法查詢「我的客戶」',
  'pages.zyConsultantOperations.diagnosisSessions.columns.customerName':
    '客戶名稱',
  'pages.zyConsultantOperations.diagnosisSessions.columns.title': '標題',
  'pages.zyConsultantOperations.diagnosisSessions.columns.diagnosisDate':
    '診斷日期',
  'pages.zyConsultantOperations.diagnosisSessions.columns.industry': '行業',
  'pages.zyConsultantOperations.diagnosisSessions.columns.intervieweeRole':
    '訪談對象',
  'pages.zyConsultantOperations.diagnosisSessions.columns.status': '狀態',
  'pages.zyConsultantOperations.diagnosisSessions.columns.overallRiskLevel':
    '總體風險',
  'pages.zyConsultantOperations.diagnosisSessions.columns.actions': '操作',
  'pages.zyConsultantOperations.diagnosisSessions.actions.detail': '詳情',
  'pages.zyConsultantOperations.diagnosisSessions.actions.run': '執行',
  'pages.zyConsultantOperations.diagnosisSessions.actions.result': '結果',
  'pages.zyConsultantOperations.diagnosisSessions.search.placeholder':
    '搜尋標題/客戶/行業',
  'pages.zyConsultantOperations.diagnosisSessions.search.statusPlaceholder':
    '狀態',
  'pages.zyConsultantOperations.diagnosisSessions.create.button':
    '新建診斷會話',
  'pages.zyConsultantOperations.diagnosisSessions.create.modalTitle':
    '新建診斷會話',
  'pages.zyConsultantOperations.diagnosisSessions.create.success':
    '診斷會話已建立',
  'pages.zyConsultantOperations.diagnosisSessions.form.pack': '題包',
  'pages.zyConsultantOperations.diagnosisSessions.form.customer': '客戶',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerPlaceholder':
    '搜尋並選擇我的客戶',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerLoadFailed':
    '載入客戶列表失敗',
  'pages.zyConsultantOperations.diagnosisSessions.form.missingMember':
    '當前會話缺少 memberUuid，無法載入「我的客戶」',
  'pages.zyConsultantOperations.diagnosisSessions.form.titleSuggestionFailed':
    '產生標題建議失敗',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerName':
    '客戶名稱',
  'pages.zyConsultantOperations.diagnosisSessions.form.title': '標題',
  'pages.zyConsultantOperations.diagnosisSessions.form.titlePlaceholder':
    '將依客戶自動產生標題，仍可手動修改',
  'pages.zyConsultantOperations.diagnosisSessions.form.diagnosisDate':
    '診斷日期',
  'pages.zyConsultantOperations.diagnosisSessions.form.industry': '行業',
  'pages.zyConsultantOperations.diagnosisSessions.form.intervieweeRole':
    '訪談對象',
  'pages.zyConsultantOperations.diagnosisSessions.form.sourceChannel':
    '來源渠道',
  'pages.zyConsultantOperations.diagnosisSessions.form.required': '此欄為必填',
  'pages.zyConsultantOperations.diagnosisSessions.status.draft': '草稿',
  'pages.zyConsultantOperations.diagnosisSessions.status.inProgress': '進行中',
  'pages.zyConsultantOperations.diagnosisSessions.status.completed': '已完成',
  'pages.zyConsultantOperations.diagnosisRun.loading': '載入中...',
  'pages.zyConsultantOperations.diagnosisRun.titlePrefix': '執行診斷',
  'pages.zyConsultantOperations.diagnosisRun.boolean.yes': '是',
  'pages.zyConsultantOperations.diagnosisRun.boolean.no': '否',
  'pages.zyConsultantOperations.diagnosisRun.field.evidenceSummary': '證據摘要',
  'pages.zyConsultantOperations.diagnosisRun.field.note': '顧問備註',
  'pages.zyConsultantOperations.diagnosisRun.action.save': '儲存答案',
  'pages.zyConsultantOperations.diagnosisRun.action.finish': '完成診斷',
  'pages.zyConsultantOperations.diagnosisRun.message.answersSaved':
    '答案已儲存',
  'pages.zyConsultantOperations.diagnosisRun.message.finished': '診斷已完成',
  'pages.zyConsultantOperations.diagnosisResult.loading': '載入中...',
  'pages.zyConsultantOperations.diagnosisResult.cardTitle': '診斷結果',
  'pages.zyConsultantOperations.diagnosisResult.card.overallRisk': '總體風險',
  'pages.zyConsultantOperations.diagnosisResult.card.highRisk': '高風險',
  'pages.zyConsultantOperations.diagnosisResult.card.mediumRisk': '中風險',
  'pages.zyConsultantOperations.diagnosisResult.card.lowRisk': '低風險',
  'pages.zyConsultantOperations.diagnosisResult.section.dimensionScores':
    '維度得分',
  'pages.zyConsultantOperations.diagnosisResult.section.highlightedQuestions':
    '重點問題',
  'pages.zyConsultantOperations.diagnosisResult.section.suggestionDirections':
    '建議方向',
  'pages.zyConsultantOperations.diagnosisResult.column.frameworkType': '框架',
  'pages.zyConsultantOperations.diagnosisResult.column.level1': '一級維度',
  'pages.zyConsultantOperations.diagnosisResult.column.level2': '二級維度',
  'pages.zyConsultantOperations.diagnosisResult.column.averageScore': '平均分',
  'pages.zyConsultantOperations.diagnosisResult.column.answeredCount':
    '已答題數',
  'pages.zyConsultantOperations.diagnosisResult.column.questionTitle': '問題',
  'pages.zyConsultantOperations.diagnosisResult.column.riskLevel': '風險',
  'pages.zyConsultantOperations.diagnosisResult.column.causeType': '歸因',
  'pages.zyConsultantOperations.diagnosisResult.column.solutionDirection':
    '方案方向',
  'pages.zyConsultantOperations.diagnosisResult.column.answer': '答案',
  'pages.zyConsultantOperations.diagnosisDetail.loading': '載入中...',
  'pages.zyConsultantOperations.diagnosisDetail.invalidUuid':
    '缺少診斷會話 uuid 參數',
  'pages.zyConsultantOperations.diagnosisDetail.titleFallback': '診斷會話',
  'pages.zyConsultantOperations.diagnosisDetail.tab.basic': '基本資訊',
  'pages.zyConsultantOperations.diagnosisDetail.tab.questions': '題包題目',
  'pages.zyConsultantOperations.diagnosisDetail.tab.analysis': '統計分析',
  'pages.zyConsultantOperations.diagnosisDetail.field.createdAt': '建立時間',
  'pages.zyConsultantOperations.diagnosisDetail.field.startedAt': '開始時間',
  'pages.zyConsultantOperations.diagnosisDetail.field.completedAt': '完成時間',
  'pages.zyConsultantOperations.diagnosisDetail.message.started':
    '診斷會話已開始',
  'pages.zyConsultantOperations.diagnosisDetail.questions.notStarted':
    '當前會話尚未開始',
  'pages.zyConsultantOperations.diagnosisDetail.questions.start': '開始並作答',
  'pages.zyConsultantOperations.diagnosisDetail.questions.empty':
    '當前會話沒有題目',
  'pages.zyConsultantOperations.diagnosisDetail.analysis.empty':
    '暫無統計分析資料，請先完成題目作答並保存',
  'pages.zyConsultantOperations.settings.tab.codeRules': '編碼規則',
  'pages.zyConsultantOperations.settings.tab.dict': '字典管理',
  'pages.zyConsultantOperations.settings.tab.taxonomy': '標籤管理',
  'pages.zyConsultantOperations.settings.dict.types': '字典類型',
  'pages.zyConsultantOperations.settings.dict.items': '字典項',
  'pages.zyConsultantOperations.settings.dict.questionCategory': '問題分類',
  'pages.zyConsultantOperations.settings.taxonomy.list': '分類法列表',
  'pages.zyConsultantOperations.settings.taxonomy.tree': '標籤樹',
  'pages.zyConsultantOperations.settings.taxonomy.aiWorkbench': 'AI 新增標籤',
  'pages.zyConsultantOperations.settings.taxonomy.generateOptions': '生成選項',
  'pages.zyConsultantOperations.settings.taxonomy.preview': '預覽結果',
  'pages.zyConsultantOperations.settings.taxonomy.previewHint':
    '勾選需要的標籤後加入標籤樹',
  'pages.zyConsultantOperations.settings.taxonomy.target': '目前落點',
  'pages.zyConsultantOperations.settings.taxonomy.targetChild':
    '作為子標籤新增',
  'pages.zyConsultantOperations.settings.taxonomy.targetRoot': '作為根標籤新增',
  'pages.zyConsultantOperations.settings.taxonomy.rootTarget': '目前分類法根級',
  'pages.zyConsultantOperations.settings.taxonomy.targetHint':
    '先在左側標籤樹點選一個標籤，可把候選統一掛到該標籤下。',
  'pages.zyConsultantOperations.settings.taxonomy.mode': '拆解方式',
  'pages.zyConsultantOperations.settings.taxonomy.modeSmart':
    '智慧拆解盡可能多',
  'pages.zyConsultantOperations.settings.taxonomy.modeCount': '拆解指定數量',
  'pages.zyConsultantOperations.settings.taxonomy.modeManual':
    '人工輸入（每行一個）',
  'pages.zyConsultantOperations.settings.taxonomy.subject': '拆解主題',
  'pages.zyConsultantOperations.settings.taxonomy.subjectPlaceholder':
    '例如：組織協同、資料治理、經營分析',
  'pages.zyConsultantOperations.settings.taxonomy.subjectPlaceholderSelected':
    '預設會圍繞已選標籤繼續細化，也可以補充更具體的主題',
  'pages.zyConsultantOperations.settings.taxonomy.targetCount': '目標數量',
  'pages.zyConsultantOperations.settings.taxonomy.manualInput': '人工輸入',
  'pages.zyConsultantOperations.settings.taxonomy.manualInputPlaceholder':
    '每行一個標籤草稿，例如：\n流程協同\n資料口徑統一\n經營復盤機制',
  'pages.zyConsultantOperations.settings.taxonomy.prompt': '拆解提示',
  'pages.zyConsultantOperations.settings.taxonomy.promptPlaceholder':
    '例如：偏顧問診斷語言、避免重複既有標籤、優先組織與流程維度',
  'pages.zyConsultantOperations.settings.taxonomy.aiMeta': '本次拆解由模型生成',
  'pages.zyConsultantOperations.settings.taxonomy.reason': '拆解依據',
  'pages.zyConsultantOperations.settings.taxonomy.emptyCandidates':
    '先選擇拆解方式並生成候選，再批次建立到標籤樹。',
  'pages.zyConsultantOperations.settings.column.code': '編碼',
  'pages.zyConsultantOperations.settings.column.name': '名稱',
  'pages.zyConsultantOperations.settings.column.description': '描述',
  'pages.zyConsultantOperations.settings.column.value': '值',
  'pages.zyConsultantOperations.settings.column.sortOrder': '排序',
  'pages.zyConsultantOperations.settings.column.enabled': '啟用',
  'pages.zyConsultantOperations.settings.column.actions': '操作',
  'pages.zyConsultantOperations.settings.action.edit': '編輯',
  'pages.zyConsultantOperations.settings.action.delete': '刪除',
  'pages.zyConsultantOperations.settings.action.refresh': '刷新',
  'pages.zyConsultantOperations.settings.action.moveTop': '移到最前',
  'pages.zyConsultantOperations.settings.action.moveUp': '上移',
  'pages.zyConsultantOperations.settings.action.moveDown': '下移',
  'pages.zyConsultantOperations.settings.action.moveBottom': '移到最後',
  'pages.zyConsultantOperations.settings.action.addCategory': '新增分類',
  'pages.zyConsultantOperations.settings.action.addChildCategory': '新增子類',
  'pages.zyConsultantOperations.settings.action.addDictItem': '新增字典項',
  'pages.zyConsultantOperations.settings.action.addDictType': '新增類型',
  'pages.zyConsultantOperations.settings.action.addTaxonomy': '新增分類法',
  'pages.zyConsultantOperations.settings.action.initEnterprisePortraitTaxonomies':
    '初始化企業畫像',
  'pages.zyConsultantOperations.settings.action.addSiblingTag': '新增同級標籤',
  'pages.zyConsultantOperations.settings.action.addRootTag': '新增根標籤',
  'pages.zyConsultantOperations.settings.action.addChildTag': '新增子標籤',
  'pages.zyConsultantOperations.settings.action.openAiModal': 'AI 新增標籤',
  'pages.zyConsultantOperations.settings.action.clearTarget': '定位到根級',
  'pages.zyConsultantOperations.settings.action.clearCandidates': '清空候選',
  'pages.zyConsultantOperations.settings.action.createSelectedCandidates':
    '建立勾選候選',
  'pages.zyConsultantOperations.settings.action.generateCandidates':
    '生成候選標籤',
  'pages.zyConsultantOperations.settings.action.resetPrompt': '清空輸入',
  'pages.zyConsultantOperations.settings.action.cancel': '取消',
  'pages.zyConsultantOperations.settings.modal.editDictItem': '編輯字典項',
  'pages.zyConsultantOperations.settings.modal.addDictType': '新增字典類型',
  'pages.zyConsultantOperations.settings.modal.addDictItem': '新增字典項',
  'pages.zyConsultantOperations.settings.message.dictItemUpdated':
    '字典項已更新',
  'pages.zyConsultantOperations.settings.message.dictItemCreated':
    '字典項已建立',
  'pages.zyConsultantOperations.settings.message.dictItemDeleted':
    '字典項已刪除',
  'pages.zyConsultantOperations.settings.message.categoryUpdated': '分類已更新',
  'pages.zyConsultantOperations.settings.message.categoryCreated': '分類已建立',
  'pages.zyConsultantOperations.settings.message.taxonomyUpdated':
    '分類法已更新',
  'pages.zyConsultantOperations.settings.message.taxonomyCreated':
    '分類法已建立',
  'pages.zyConsultantOperations.settings.message.taxonomyDeleted':
    '分類法已刪除',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesInitialized':
    '企業畫像分類法已初始化',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesCreated':
    '新增分類法',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTagsCreated':
    '新增標籤',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesSkipped':
    '跳過分類法',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTagsSkipped':
    '跳過標籤',
  'pages.zyConsultantOperations.settings.message.tagUpdated': '標籤已更新',
  'pages.zyConsultantOperations.settings.message.tagCreated': '標籤已建立',
  'pages.zyConsultantOperations.settings.message.tagDeleted': '標籤已刪除',
  'pages.zyConsultantOperations.settings.message.selectTaxonomyFirst':
    '請先選擇一個分類法',
  'pages.zyConsultantOperations.settings.message.aiCandidatesReady':
    '已生成候選標籤',
  'pages.zyConsultantOperations.settings.message.selectCandidateFirst':
    '請至少勾選一條候選標籤',
  'pages.zyConsultantOperations.settings.message.aiCreatePartial':
    '候選標籤建立完成',
  'pages.zyConsultantOperations.settings.message.aiCreateSuccess':
    '候選標籤已批次建立',
  'pages.fieldResearch.records.title': '現場調研執行記錄',
  'pages.fieldResearch.records.search.placeholder': '搜索客戶或標題',
  'pages.fieldResearch.records.search.status': '狀態',
  'pages.fieldResearch.records.create': '新增執行記錄',
  'pages.fieldResearch.records.columns.title': '標題',
  'pages.fieldResearch.records.columns.customer': '客戶',
  'pages.fieldResearch.records.columns.researchDate': '調研日期',
  'pages.fieldResearch.records.columns.status': '狀態',
  'pages.fieldResearch.records.columns.updatedAt': '更新時間',
  'pages.fieldResearch.records.columns.actions': '操作',
  'pages.fieldResearch.records.actions.continue': '繼續執行',
  'pages.fieldResearch.records.actions.view': '查看面板',
  'pages.fieldResearch.records.form.customer': '客戶',
  'pages.fieldResearch.records.form.customerPlaceholder': '請選擇客戶',
  'pages.fieldResearch.records.form.title': '標題',
  'pages.fieldResearch.records.form.titlePlaceholder': '可選，預設自動生成',
  'pages.fieldResearch.records.form.researchDate': '調研日期',
  'pages.fieldResearch.records.status.draft': '草稿',
  'pages.fieldResearch.records.status.inProgress': '進行中',
  'pages.fieldResearch.records.status.completed': '已完成',
  'pages.fieldResearch.records.status.archived': '已歸檔',
  'pages.fieldResearch.panel.loading': '執行面板加載中...',
  'pages.fieldResearch.panel.left.customer': '客戶資訊',
  'pages.fieldResearch.panel.left.questions': '問題搜索',
  'pages.fieldResearch.panel.left.tasks': '任務',
  'pages.fieldResearch.panel.left.tab.question': '直接搜問題',
  'pages.fieldResearch.panel.left.tab.tag': '先搜標籤',
  'pages.fieldResearch.panel.left.searchPlaceholder': '搜索問題標題/提問語',
  'pages.fieldResearch.panel.left.tagSearchPlaceholder':
    '先搜索標籤，再查看相關問題',
  'pages.fieldResearch.panel.left.tagRelatedQuestions': '相關問題',
  'pages.fieldResearch.panel.left.tagSelectHint': '請選擇一個標籤查看相關問題',
  'pages.fieldResearch.panel.left.tagEmpty': '沒有匹配的標籤',
  'pages.fieldResearch.panel.left.tagQuestionEmpty': '該標籤下暫無問題',
  'pages.fieldResearch.panel.left.detail': '查看詳情',
  'pages.fieldResearch.panel.left.addToInterview': '添加到訪談',
  'pages.fieldResearch.panel.middle.records': '訪談記錄',
  'pages.fieldResearch.panel.middle.addFree': '新增自由記錄',
  'pages.fieldResearch.panel.middle.save': '手動保存',
  'pages.fieldResearch.panel.middle.autoSaved': '已自動保存',
  'pages.fieldResearch.panel.middle.localDraft': '網路異常，已本地暫存',
  'pages.fieldResearch.panel.right.ai': 'AI 對話',
  'pages.fieldResearch.panel.right.related': '關聯資訊',
  'pages.fieldResearch.panel.right.relatedSearchPlaceholder':
    '搜索當前區域內容',
  'pages.fieldResearch.panel.right.relatedPin': '固定',
  'pages.fieldResearch.panel.right.relatedPinned': '已固定',
  'pages.fieldResearch.panel.right.askPlaceholder':
    '請輸入現場問題，AI 會給出建議與依據',
  'pages.fieldResearch.panel.right.send': '發送',
  'pages.fieldResearch.panel.action.complete': '完成執行',
  'pages.fieldResearch.panel.entry.type.question': '問題記錄',
  'pages.fieldResearch.panel.entry.type.free': '自由記錄',
  'pages.fieldResearch.panel.entry.content': '記錄內容',
  'pages.fieldResearch.panel.entry.evidence': '證據備註',
  'pages.fieldResearch.panel.entry.signals': '關鍵信號（逗號分隔）',
  'pages.fieldResearch.panel.entry.remove': '刪除',
  'pages.fieldResearch.panel.entry.title': '記錄標題',
  'pages.fieldResearch.panel.entry.save': '保存',
};
